/* eslint-disable */
export default [
  {
    path: '/sso-center',
    name: 'SsoCenter',
    component: () => import('@/layouts/main.vue'),
    children: [
      {
        path: 'sso-manage/list',
        name: 'SsoCenterSsoManageList',
        component: () => import('@/views/sso-center/sso-manage/list.vue'),
        meta: {
          title: 'SSO中心',
          noCache: false,
          auth: true,
        },
      },
      {
        path: 'sso-manage/detail/:id',
        name: 'SsoCenterSsoManageDetail',
        component: () => import('@/views/sso-center/sso-manage/detail.vue'),
        meta: {
          title: 'SSO中心详情',
          noCache: false,
          auth: true,
        },
      },
    ],
  },
];
